import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import PublicLayout from '../components/PublicLayout';

/**
 * Reusable layout for legal pages — gives a consistent typography + container.
 */
export const LegalLayout = ({ title, subtitle, lastUpdated, children }) => {
  const { theme } = useTheme();
  return (
    <PublicLayout>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <header className="mb-10">
          {subtitle && (
            <p className="text-[11px] uppercase tracking-[0.25em] mb-2" style={{ color: theme.textMuted }}>
              {subtitle}
            </p>
          )}
          <h1 className="text-4xl sm:text-5xl font-light tracking-tight mb-3" style={{ color: theme.accent }}>
            {title}
          </h1>
          {lastUpdated && (
            <p className="text-xs" style={{ color: theme.textMuted }}>Última actualización: {lastUpdated}</p>
          )}
        </header>

        <div
          className="legal-content space-y-6 text-sm leading-relaxed"
          style={{ color: theme.textSecondary }}
        >
          {children}
        </div>
      </article>

      <style>{`
        .legal-content h2 {
          font-size: 1.35rem;
          font-weight: 500;
          letter-spacing: -0.01em;
          margin-top: 2rem;
          margin-bottom: 0.85rem;
          color: ${theme.textPrimary};
        }
        .legal-content h3 {
          font-size: 1.05rem;
          font-weight: 500;
          margin-top: 1.25rem;
          margin-bottom: 0.5rem;
          color: ${theme.textPrimary};
        }
        .legal-content p { margin-bottom: 0.85rem; }
        .legal-content ul {
          list-style: disc;
          padding-left: 1.5rem;
          margin-bottom: 1rem;
        }
        .legal-content ul li { margin-bottom: 0.4rem; }
        .legal-content strong { color: ${theme.textPrimary}; font-weight: 600; }
        .legal-content a { color: ${theme.accent}; text-decoration: underline; }
        .legal-content .info-box {
          background: ${theme.card};
          border: 1px solid ${theme.border};
          border-radius: 0.75rem;
          padding: 1rem 1.25rem;
          margin: 1.5rem 0;
        }
        .legal-content .info-box .label {
          font-size: 0.65rem;
          text-transform: uppercase;
          letter-spacing: 0.2em;
          color: ${theme.textMuted};
          margin-bottom: 0.5rem;
        }
        .legal-content .info-box .row {
          display: flex; gap: 0.5rem;
          font-size: 0.85rem;
          padding: 0.25rem 0;
        }
        .legal-content .info-box .row .key {
          min-width: 160px;
          color: ${theme.textMuted};
        }
        .legal-content .info-box .row .val {
          color: ${theme.textPrimary};
          font-weight: 500;
        }
      `}</style>
    </PublicLayout>
  );
};

export default LegalLayout;
